import { gql } from '@apollo/client';

export interface PulseAssessmentRequest {
    id: string;
    assessmentUrl: string;
    invitationId: string;
    status: string;
    completedAt: number;
    results: any;
}

export const PULSE_ASSESSMENT_REQUEST = gql`
    query PulseAssessmentRequest($personId: String!, $jobId: String!) {
        assessmentRequests: pulse_assessment_requests(where: { personId: { _eq: $personId }, jobId: { _eq: $jobId } }) {
            id
            assessmentUrl
            invitationId
            status
            completedAt
            results
        }
    }
`;

export const CREATE_PULSE_ASSESSMENT = gql`
    mutation CreatePulseAssessment($personId: String!, $jobId: String!) {
        createPulseAssessment(personId: $personId, jobId: $jobId)
    }
`;
